import { pickBy, identity } from 'lodash';

import { httpV1 as http } from '../api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function getBasics({ account_id, params }) {
  const response = await http.get(`/clients/${account_id}`, { params });
  return response;
}

export async function getDocument(accountId, qualificationId) {
  const response = await http.get(`/clients/${accountId}/qualification/${qualificationId}`);
  return response;
}

export async function getAddress(accountId, addressId) {
  const response = await http.get(`/clients/${accountId}/address/${addressId}`);
  return response;
}

export async function getIncome(accountId, professionalId) {
  const response = await http.get(`/clients/${accountId}/professional/${professionalId}`);
  return response;
}

export async function getBankAccount(accountId, bankAccountId) {
  const response = await http.get(`/clients/${accountId}/bank-account/${bankAccountId}`);
  return response;
}

export async function getVehicle(accountId, vehicleId) {
  const response = await http.get(`/clients/${accountId}/vehicle/${vehicleId}`);
  return response;
}

export async function updateBasics(accountId, params) {
  const { data } = await http.put(`/clients/${accountId}`, params);
  return data;
}

export async function createDocument(params) {
  const { data } = await http.post('/clients/qualification/admin', params);
  return data;
}

export async function updateDocument(accountId, qualificationId, params) {
  const { data } = await http.put(`/clients/${accountId}/qualification/${qualificationId}`, params);
  return data;
}

export async function createAddress(params) {
  const { data } = await http.post('/clients/address/admin', params);
  return data;
}

export async function updateAddress(accountId, addressId, params) {
  const { data } = await http.put(`/clients/${accountId}/address/${addressId}`, params);
  return data;
}

export async function getProfessionalList(params) {
  const { data } = await http.get('/clients/professions/list', { params });
  return data;
}

export async function createIncome(params) {
  const { data } = await http.post('/clients/professional/admin', params);
  return data;
}

export async function updateIncome(accountId, professionalId, params) {
  const { data } = await http.put(`/clients/${accountId}/professional/${professionalId}`, params);
  return data;
}

export async function createBankAccount(params) {
  const { data } = await http.post('/clients/bank-account/admin', params);
  return data;
}

export async function updateBankAccount(accountId, bankAccountId, params) {
  const { data } = await http.put(`${ALT_API_URL}/clients/${accountId}/bank-account/${bankAccountId}`, params);
  return data;
}

export async function createVehicle(params) {
  const { data } = await http.post('/clients/vehicle/admin', params);
  return data;
}

export async function updateVehicle(accountId, vehicleId, params) {
  const { data } = await http.put(`/clients/${accountId}/vehicle/${vehicleId}`, params);
  return data;
}

export async function createBasic(data) {
  const { data: _data } = await http.post('/clients/account/admin', data);
  return _data;
}

export async function checkUniqueAccount({ document, ...params }) {
  return http.get(`/clients/account/${document}`, { params });
}

export async function getClientData(document) {
  const { data } = await http.get('/cgv/credit-check-consent', { params: { document } });
  return data;
}

export async function getProfessionCategoryList(params) {
  const { data } = await http.get('/clients/profession-categories/list', { params });
  return data;
}

/**
 * Get Screening List
 * @function getCorbanScreenings
 * @param {number} screeningId - The Screening ID
 * @param {string} begin_date - The start of the range to filter created_at attribute
 * @param {string} end_date - The ending of the range to filter created_at attribute
 * @param {string} status - The screening status to filter, might be one of the following [
 *  "reprovado",
 *  "aprovado",
 *  "em-analise"
 * ]. Set by default to "em-analise"
 * @returns {any}
 */
export async function getCorbanScreenings(screeningId = '', begin_date = '', end_date = '', status = 'em-analise') {
  const params = pickBy({ begin_date, end_date, status }, identity);
  let requestURL = '/clients/corban-prospection';

  requestURL += screeningId ? `/${(screeningId)}` : '';

  const { data } = await http.get(requestURL, { params });
  return data;
}

/**
 * Change screening status, by default set it to approved
 * @function updateCorbanScreeningStatus
 * @param {number} screeningId - The screening ID
 * @param {string} status - The screening Status, might be one of the following [
 *  "reprovado",
 *  "aprovado",
 *  "em-analise"
 * ]
 * @param {number | undefined} observation - The observation (if needed)
 * @returns {any}
 */
export async function updateCorbanScreeningStatus(screeningId, observation, status = 'aprovado') {
  const { data } = await http.put(`/clients/corban-prospection/${screeningId}`, { status, observation });
  return data;
}
